import { UserInterfaceIdiomProvider } from '@psl/appComponents/UserInterfaceIdiomContext';
import type { EmbeddedWebViewProps } from '@psl/flows/common/embedded-webview/EmbeddedWebView';
import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const EmbeddedWebView = lazy(() => import('./EmbeddedWebView'));

export default wrapLazyNavigatorScreen((props: EmbeddedWebViewProps) => {
  return (
    <UserInterfaceIdiomProvider
      userInterfaceStyle="light"
      name="embedded-webview"
    >
      <EmbeddedWebView {...props} />
    </UserInterfaceIdiomProvider>
  );
});
